// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2hGS7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1kD5_"};